var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNounWhereToGo2 = function SvgNounWhereToGo2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 10 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m64 29.332c-12.309 0-22.57 9.3398-22.57 22.57 0 5.0273 1.9453 10.945 4.0312 14.836l16.398 30.633c0.41797 0.79688 1.2422 1.2969 2.1406 1.2969s1.7227-0.5 2.1406-1.2969l16.398-30.633c2.0859-3.8906 4.0312-9.8125 4.0312-14.836 0-13.23-10.262-22.57-22.57-22.57zm0 4.8359c9.9531 0 17.734 6.9258 17.734 17.734 0 3.6367-1.8047 9.4727-3.4492 12.543l-14.285 26.629-14.281-26.625c-1.6484-3.0742-3.4531-8.9062-3.4531-12.547 0-10.809 7.7812-17.734 17.734-17.734zm0 6.4492c-6.2031 0-11.285 5.082-11.285 11.285s5.082 11.285 11.285 11.285 11.285-5.082 11.285-11.285-5.082-11.285-11.285-11.285zm0 4.8359c3.5898 0 6.4492 2.8594 6.4492 6.4492s-2.8594 6.4492-6.4492 6.4492-6.4492-2.8594-6.4492-6.4492 2.8594-6.4492 6.4492-6.4492z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNounWhereToGo2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noun-where-to-go-2.df5c3352.svg";
export { ForwardRef as ReactComponent };